import * as React from 'react';
import { connect } from 'react-redux';
import { photoCaptureIntelligentViewChangeAction } from '../actions';
import { AlbumHierarchyComponent } from '../components';
import { getPhotoCaptureEstimatorConfiguration, getIsConfidence, getPhotoCaptureAttachmentInfo, getPhotoCaptureCountryCode, getPhotoCapturePrtcDetailsData, getPhotoCaptureUserVehicleInfo, getPhotoCaptureVehicle } from '../selectors';
const mapStateToProps = (state, ownProps) => {
    const { vinOption } = getPhotoCaptureEstimatorConfiguration(state) || {};
    return {
        countryCode: getPhotoCaptureCountryCode(state),
        photoCaptureAttachmentInfo: getPhotoCaptureAttachmentInfo(state),
        photoCaptureVehicle: getPhotoCaptureVehicle(state),
        isConfidence: getIsConfidence(state),
        prtcDetailsData: getPhotoCapturePrtcDetailsData(state),
        userVehicleInfo: getPhotoCaptureUserVehicleInfo(state),
        vinOption
    };
};
const mapDispatchToProps = (dispatch) => ({
    onViewChange: (view, sequenceScreenName, selectedTileId, contentType) => {
        dispatch(photoCaptureIntelligentViewChangeAction(view, sequenceScreenName, selectedTileId, contentType));
    }
});
export const PhotoCaptureAlbumHierarchyComponentWrapper = (props) => {
    return React.createElement(AlbumHierarchyComponent, Object.assign({}, props));
};
export const ConnectedPhotoCaptureAlbumHierarchyComponent = connect(mapStateToProps, mapDispatchToProps)(PhotoCaptureAlbumHierarchyComponentWrapper);
//# sourceMappingURL=ConnectedPhotoCaptureAlbumHierarchyComponent.js.map